import Work3 from "../../assets/Work3.png";
import Work4 from "../../assets/Work4.png";
import Work6 from "../../assets/Work6.png";

export const projectsData = [
    {
        id: 1,
        image: Work6,
        title: 'Village Association Website',
        subtitle: 'React, Tailwind CSS, Vercel',
        category: 'web',
        liveUrl: null,
        githubUrl: null,
    },
    {
        id: 2,
        image: Work3,
        title: 'Immigration Door Platform',
        subtitle: 'React, Node.js, Full-Stack',
        category: 'web',
        liveUrl: null,
        githubUrl: null,
    },
    {
        id: 3,
        image: Work4,
        title: 'FinFlow — Financial Tracker',
        subtitle: 'React, AWS, PostgreSQL, JWT Auth',
        category: 'app',
        liveUrl: null,
        githubUrl: null,
    },
    {
        id: 4,
        image: null,
        title: 'Photographer Portfolio — Jared Reyes',
        subtitle: 'Next.js, TypeScript, Tailwind CSS, Framer Motion',
        category: 'web',
        liveUrl: 'https://photographer-portfolio-coral-chi.vercel.app/',
        githubUrl: 'https://github.com/KarimFarag0/photographer-portfolio',
    },
];

export const projectsNav = [
    { name: 'all' },
    { name: 'web' },
    { name: 'app' },
];
